import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormCheckboxListComplexBaseComponent } from '../base-complex/form-checkbox-list-complex-base.component';
import { GetDisabledMsgPipe } from '../../../../pipes/disabled-message.pipe';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { NgClass, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'sh-form-checkbox-list-base',
    templateUrl: '../base-complex/form-checkbox-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormCheckboxListBaseComponent)],
    standalone: true,
    imports: [NgClass, NgFor, ShIndeterminateDirective, AsyncPipe, GetDisabledMsgPipe]
})
export class ShFormCheckboxListBaseComponent extends ShFormCheckboxListComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        const unwrapped: any = formValues
            .filter(fv => fv.state === FormValueState.SET)
            .map(FormValue.unwrap.bind(this));
        super.propagateChange(unwrapped);
    }

    writeValue(obj: any[]): void {
        const base: any[] = obj instanceof Array ? obj : [];
        super.writeValue(base.map(el => FormValue.wrap(el)));
    }
}
